import { intersection } from "lodash";
import type { ProgramFilterStateType } from "src/lib/contexts/ContextTypes";
import { type ProgramMovie } from "src/lib/types/filminfo/ProgramMovie";

export type FilteredMovies = {
    movies: ProgramMovie[];
    numFilteredMovies: number;
    numFilteredShows: number;
}

/**
 * Applies the user's filters (genres, selected cinemas) and counts what they hide.
 * On a cinema page (predefinedCinema) the program is first limited to that cinema - that isn't
 * a filter the user chose, so the other cinemas' shows are neither shown nor counted as hidden.
 */
export default function filterMoviesAndShows(movies: ProgramMovie[], filterContext: ProgramFilterStateType, selectedCinemas: string[] | null, predefinedCinema?: string): FilteredMovies {
    console.debug("CINEMA FILTER", selectedCinemas)
    let numMovies = 0;
    let numShows = 0;
    const baseGenres = filterContext.genres || [];
    const genres = baseGenres.includes("Familiefilm")
        ? [...baseGenres, "Barnefilm", "Familie"]
        : baseGenres;
    const cinemaMovies = !predefinedCinema ? movies : movies
        .map(mov => ({ ...mov, showsWithDate: mov.showsWithDate.filter(s => s.theaterName === predefinedCinema) }))
        .filter(mov => mov.showsWithDate.length > 0);
    let movs = cinemaMovies.filter(mov => {
        // first apply filters that will match whole movies
        /*
        if (filterContext.highlightPremieres && !mov.isPremieringThisWeek) {
            numMovies++;
            numShows += mov.shows?.length ?? 0;
            return false;
        }*/

        if (genres.length) {
            // genre filtering is on, but the movie does not have any genres, OR none of the genres match
            if (!(mov.genres!.length && intersection(mov.genres, genres).length)) {
                numMovies++;
                numShows += mov.showsWithDate.length;
                return false;
            }
        }

        return true;
    });

    movs = movs.map(oldMov => {
        const mov = { ...oldMov };
        // filter shows for movie
        mov.filteredShows = mov.showsWithDate;
        /*
        if (filterContext.perspective.length) {
            // Not having any dimensions selected is the same as haveing all dimensions selected:
            mov.filteredShows = mov.filteredShows.filter(s => !!intersection(s.perspectives, filterContext.perspective).length);
        }*/

        if (selectedCinemas?.length) {
            // not haveing any cinemas selected is the same as having all cinemas selected:
            mov.filteredShows = mov.filteredShows.filter(s => selectedCinemas.includes(s.theaterName!));
        }
        /*
        if (filterContext.timeIntervals?.length) {
            mov.filteredShows = mov.filteredShows.filter(s => filterContext.timeIntervals.some(interval => interval(s.dateShowStart)));
        }
        if (filterContext.highlightKinoklubb) {
            mov.filteredShows = mov.filteredShows.filter(s => {
                return mov.isKinoklubb && s.isKinoklubb;
            });
        }*/
        // if all shows have not been filtered away, the movie should be shown
        numShows += mov.showsWithDate.length - mov.filteredShows.length;
        if (!mov.filteredShows.length) {
            numMovies++;
        }
        return mov;
    });

    movs = movs.filter(mov => {
        return (mov.filteredShows?.length ?? 0) !== 0;
    });



    return { movies: movs, numFilteredMovies: numMovies, numFilteredShows: numShows };

}
